import * as React from 'react';
import {view} from '@sail/ui';
import {getStore} from 'src/v2/state/store';
import {LinkLogo} from 'src/v2/components/screen/link/LinkLogo';
import {Link} from 'src/v2/components/common';

interface LinkTitleWrapperProps {
  children: React.ReactNode;
}

export const LinkTitleWrapper = ({children}: LinkTitleWrapperProps) => {
  const store = getStore();

  const consumerAccount = store.useSelector((state) => state.consumerAccount);

  return (
    <view.div
      css={{
        stack: 'y',
        paddingTop: consumerAccount ? undefined : 'small',
        paddingBottom: 'medium',
        flex: 'none',
      }}
      data-testid="v2-heading"
    >
      {consumerAccount ? (
        <>
          <view.div css={{marginBottom: '3px'}}>
            <Link
              href="https://link.com/"
              target="_blank"
              aria-label="Link logo"
            >
              <LinkLogo />
            </Link>
          </view.div>
          <view.div
            css={{
              width: 'calc(100% + 48px)',
              height: 'space.1',
              backgroundColor: '#e3e8ee',
              marginTop: 'medium',
              marginBottom: 'xlarge',
              marginLeft: '-24px',
              marginRight: '-24px',
            }}
          />
        </>
      ) : null}
      <view.div
        css={{
          stack: 'y',
          alignX: 'center',
          alignY: 'center',
          gapY: '3px',
        }}
      >
        {children}
      </view.div>
    </view.div>
  );
};
